"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const icons_1 = require("./icons");
const GenericSelectionOverlay_1 = __importDefault(require("./GenericSelectionOverlay"));
const NoForms_1 = __importDefault(require("../NoForms"));
function TabPanel(props) {
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ role: "tabpanel", hidden: value !== index, id: `code-preview-tabpanel-${index}`, "aria-labelledby": `code-preview-tab-${index}` }, other, { style: { height: '100%' }, children: value === index && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { p: 0, height: '100%' }, children: children })) })));
}
const CodePreview = ({ code, title = "Generated Code", height = 400, showTabs = true, onRefresh, editable = false, onCodeChange, isDragging = false }) => {
    const [tabValue, setTabValue] = (0, react_1.useState)(0);
    const [copied, setCopied] = (0, react_1.useState)(false);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const handleCopyCode = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
        catch (err) {
            console.error('Failed to copy code:', err);
        }
    });
    const handleDownloadCode = () => {
        const blob = new Blob([code], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'generated-code.html';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    const formatCode = (code) => {
        // Basic HTML formatting for better readability
        return code
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/\n/g, '<br>')
            .replace(/\s{2}/g, '&nbsp;&nbsp;');
    };
    if (!code) {
        return ((0, jsx_runtime_1.jsx)(NoForms_1.default, { icon: (0, jsx_runtime_1.jsx)(icons_1.FormLogoIcon, { width: 48, height: 48 }), title: "Start Building Your Form", description: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "This space will show your form preview as you design." }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Paper, { sx: { height, width: '100%', display: 'flex', flexDirection: 'column' }, children: [showTabs ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: { display: 'flex', justifyContent: 'center', py: 2 }, children: (0, jsx_runtime_1.jsxs)(material_1.ToggleButtonGroup, { value: tabValue, exclusive: true, onChange: (_, val) => typeof val === 'number' && setTabValue(val), sx: {
                                background: '#f4f3f7',
                                borderRadius: '999px',
                                p: '4px',
                                display: 'inline-flex',
                            }, children: [(0, jsx_runtime_1.jsx)(material_1.ToggleButton, { value: 0, sx: {
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: 48,
                                        height: 48,
                                        backgroundColor: tabValue === 0 ? '#232230' : 'transparent',
                                        color: tabValue === 0 ? '#fff' : '#232230',
                                        transition: 'background 0.2s',
                                        '&:hover': { backgroundColor: tabValue === 0 ? '#232230' : '#e0e0e0' },
                                        mx: 1,
                                    }, children: (0, jsx_runtime_1.jsx)(icons_material_1.Visibility, {}) }), (0, jsx_runtime_1.jsx)(material_1.ToggleButton, { value: 1, sx: {
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: 48,
                                        height: 48,
                                        backgroundColor: tabValue === 1 ? '#232230' : 'transparent',
                                        color: tabValue === 1 ? '#fff' : '#232230',
                                        transition: 'background 0.2s',
                                        '&:hover': { backgroundColor: tabValue === 1 ? '#232230' : '#e0e0e0' },
                                        mx: 1,
                                    }, children: (0, jsx_runtime_1.jsx)(icons_material_1.Code, {}) })] }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { flex: 1, overflow: 'hidden' }, children: [(0, jsx_runtime_1.jsx)(TabPanel, { value: tabValue, index: 0, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { height: '100%', overflow: 'auto' }, children: (0, jsx_runtime_1.jsx)(GenericSelectionOverlay_1.default, { code: code, isDragging: isDragging }) }) }), (0, jsx_runtime_1.jsx)(TabPanel, { value: tabValue, index: 1, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                                        height: '100%',
                                        overflow: 'auto',
                                        backgroundColor: '#f5f5f5',
                                        p: 2
                                    }, children: editable ? ((0, jsx_runtime_1.jsx)(material_1.TextField, { multiline: true, minRows: 10, maxRows: 30, fullWidth: true, value: code, onChange: e => onCodeChange === null || onCodeChange === void 0 ? void 0 : onCodeChange(e.target.value), sx: { fontFamily: 'monospace', fontSize: '12px', background: '#f5f5f5' } })) : ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "pre", sx: {
                                            margin: 0,
                                            fontSize: '12px',
                                            lineHeight: 1.5,
                                            fontFamily: 'monospace',
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word',
                                            backgroundColor: 'transparent',
                                            color: '#333'
                                        }, dangerouslySetInnerHTML: { __html: formatCode(code) } })) }) })] })] })) : (
            /* Single Preview Mode */
            (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { flex: 1, overflow: 'auto' }, children: (0, jsx_runtime_1.jsx)(GenericSelectionOverlay_1.default, { code: code, isDragging: isDragging }) })), copied && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    color: 'white',
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    zIndex: 1000,
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", children: "Code copied!" }) }))] }));
};
exports.default = CodePreview;
